import { Component, inject, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CheckBoxAction, ActionColor } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ElementModel } from 'src/app/models/maintenance/element.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MaintenanceActivitiesTableModel } from 'src/app/models/tables/maintenance/maintenance-activities-table.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaintenanceRoutineDetailService } from 'src/app/services/maintenance/maintenance-routine-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-maintenance-routine-detail',
  templateUrl: './register-maintenance-routine-detail.component.html',
  styleUrls: ['./register-maintenance-routine-detail.component.scss'],
  standalone: false
})
export class RegisterMaintenanceRoutineDetailComponent implements OnInit {
  public config = inject(DynamicDialogConfig);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly maintenanceRoutineDetailService = inject(MaintenanceRoutineDetailService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  @Optional() private ref = inject(DynamicDialogRef);

  ascendant: boolean = true;
  columnSort: string | null = null;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Agregar',
      icon: '',
      color: ActionColor.SUCCESS,
      action: 'add'
    },
  ];
  data: PagedResponseModel<MaintenanceActivitiesTableModel> = new PagedResponseModel<MaintenanceActivitiesTableModel>();
  elementModel: ElementModel = new ElementModel();
  filters: ColumnResponseModel[] = [];
  columns: ColumnResponseModel[] = [];
  limit: number = 10;
  page: number = 1;
  suscription: Subscription;

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.elementModel = inputs.elementModel;
    });

    await Promise.all([
      this.getColumns(),
      this.getMaintenanceActivitiesForSelection()
    ])

  }


  private async createMultipleDetailsAsync(selectedItems: number[]) {
    try {
      const response = await firstValueFrom(this.maintenanceRoutineDetailService.createMultipleDetailsAsync(selectedItems, this.elementModel.elementId));
      if (response) {
        const output$ = this.config.data?.output$;
        output$?.next({ type: 'updateList', payload: true });
        this.toastHandlerService.showToast('success', 'Las actividades se agregaron exitosamente.', '');
      }
      if (this.ref) this.ref.close();
    } catch (error) {
      console.error('Error al agregar las actividades.', error);
    }
  }


  async getColumns() {
    try {
      this.columns = await firstValueFrom(this.maintenanceRoutineDetailService.getColumnsForActivitiesAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getMaintenanceActivitiesForSelection() {
    try {
      this.data = await firstValueFrom(this.maintenanceRoutineDetailService.getMaintenanceActivitiesForSelectionAsync(this.page, this.limit,
        this.columnSort, this.ascendant, this.filters, this.elementModel.elementId));
    } catch (error) {
      console.error('Error al obtener la lista de las actividades.', error);
    }
  }

  async onAction(event: { action: string, item?: MaintenanceActivitiesTableModel, selectedItems?: number[] }) {
    if (event.action == 'add' && event.selectedItems) {
      await this.createMultipleDetailsAsync(event.selectedItems);
    } else {
      console.error('No se seleccionaron items.');
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getMaintenanceActivitiesForSelection()
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }
}
